var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_4488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1250_4488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H7V23H23V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1250_4488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 12.9992L17.765 13.0092C17.2157 11.4259 15.557 10.3325 13.833 10.3325C11.627 10.3325 9.66634 12.1259 9.66634 14.3325V14.4165C8.99967 14.7132 7.83301 15.7592 7.83301 16.9999C7.83301 18.4706 9.19567 19.6666 10.6663 19.6666H17.9997C19.8377 19.6666 21.333 18.1706 21.333 16.3332C21.333 14.4959 19.8377 12.9992 17.9997 12.9992ZM17.9997 18.3332H14.9997V15.8039L16.4303 17.2346C16.4613 17.2656 16.4981 17.2902 16.5386 17.307C16.5791 17.3238 16.6225 17.3325 16.6663 17.3325C16.7102 17.3325 16.7536 17.3238 16.7941 17.307C16.8346 17.2902 16.8714 17.2656 16.9023 17.2346C16.9648 17.1721 16.9999 17.0873 16.9999 16.9989C16.9999 16.9105 16.9648 16.8257 16.9023 16.7632L14.9037 14.7632L14.7943 14.6919C14.7539 14.6751 14.7105 14.6664 14.6667 14.6664C14.6229 14.6664 14.5795 14.6751 14.539 14.6919L14.431 14.7632L12.431 16.7632C12.3685 16.8257 12.3334 16.9105 12.3334 16.9989C12.3334 17.0873 12.3685 17.1721 12.431 17.2346C12.4939 17.2966 12.5787 17.3314 12.667 17.3314C12.7553 17.3314 12.8401 17.2966 12.903 17.2346L14.333 15.8039V18.3332H10.6663C9.93034 18.3332 9.33301 17.7359 9.33301 16.9999C9.33301 16.2639 9.93034 15.6665 10.605 15.6632L11.553 15.6732L11.3877 14.8725C11.3081 14.4848 11.3157 14.0842 11.4101 13.6998C11.5044 13.3153 11.683 12.9567 11.9331 12.6498C12.1831 12.3429 12.4982 12.0955 12.8556 11.9254C13.2131 11.7554 13.6038 11.6669 13.9997 11.6665C14.629 11.6661 15.2381 11.8894 15.718 12.2965C16.1979 12.7037 16.5175 13.2682 16.6197 13.8892L16.7443 14.6239L17.4597 14.4199C17.6677 14.3605 17.839 14.3332 18.001 14.3332C19.103 14.3332 20.001 15.2305 20.001 16.3332C20.001 17.4359 19.1023 18.3332 17.9997 18.3332Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_4488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/Storage.3d006a91683ae5eba962c8bdb89cbf0b.svg";
export { ForwardRef as ReactComponent };